import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const APP_V2_PREFIX = '/app-v2'

const isHandledByLegacy = (path: string): boolean =>
  path.startsWith('/') &&
  path !== APP_V2_PREFIX &&
  !path.startsWith(`${APP_V2_PREFIX}/`)

export const useNativeNavigate = (): void => {
  const history = useHistory()

  useEffect(() => {
    window.__nativeNavigate = (path: string): boolean => {
      if (typeof path !== 'string' || !isHandledByLegacy(path)) return false

      const { pathname, search, hash } = history.location
      const currentPath = `${pathname}${search}${hash}`

      if (path === currentPath || path === pathname) return true

      history.push(path)

      return true
    }

    return () => {
      delete window.__nativeNavigate
    }
  }, [history])
}
